module.exports = __webpack_public_path__ + "img/icon-plant-2.8819b80e.svg";